import { axios, handleApiError } from "./Api";

const ClientApi = {
  /**
   * Get Client Data
   * @param {Number} client_id
   */
  async getClient(client_id) {
    return axios
      .get(axios.defaults.baseURL + "/client/" + client_id)
      .then(response => {
        return response.data.client;
      })
      .catch(handleApiError);
  }
};

export default ClientApi;
